// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"4ed19bf1","948":"8195b9bf"}[chunkId] + ".chunk.js";
};